/**
 * @fileoverview DELETE handler for the "/alloys/amazon-bedrock/agentic/:app_group_id/external_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAlloysAmazonBedrockAgenticExternalIdCacheKeys } from "./constants";
import type {
  DeleteAlloysAmazonBedrockAgenticExternalIdProps,
  DeleteAlloysAmazonBedrockAgenticExternalIdResult,
} from "./types";

/**
 * Discards the app group's pending Amazon Bedrock STS external ID, so a saved
 * role-auth integration shows its saved external ID again.
 */
export const deleteAlloysAmazonBedrockAgenticExternalId = reactQueryMutationAdapter(
  deleteAlloysAmazonBedrockAgenticExternalIdCacheKeys,
  (
    props: DeleteAlloysAmazonBedrockAgenticExternalIdProps
  ): Promise<DeleteAlloysAmazonBedrockAgenticExternalIdResult> => {
    return fetch(`/alloys/amazon-bedrock/agentic/${props.appGroupId}/external_id`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
